import { PARAMETER_FORMDATA, PARAMETER_PAYMENT_TOKEN, PARAMETER_RESTORE_FORM_DATA, PARAMETER_TRANSACTION_ID } from "../../../../pages/config/settings";
import { SessionContextType } from "../../../../context/SessionContext";
import { SESSION_PARAM_PRODUCT_FORM_DATA } from "../../../doctypes/P020DonationProduct/P020DonationProductForm";


/**
 * Checks if the current URL indicates an aborted payment or if the restore flag is set
 * @param url The URL to check
 * @param session The session context
 * @returns True if the payment was aborted or the restore flag is set
 */
export function isAbortedPayment(session: SessionContextType): boolean {
    return session.getFromSession(PARAMETER_RESTORE_FORM_DATA) === "true";
}

/**
 * Cleans up payment-related data from the session after an aborted payment
 * @param session The session context
 */
export function cleanupAbortedPaymentData(session: SessionContextType): void {
    session.removeFromSession(PARAMETER_TRANSACTION_ID);
    session.removeFromSession(PARAMETER_PAYMENT_TOKEN);
}

/**
 * Gets form data from the session
 * @param session The session context
 * @returns The form data from the session, or null if not found
 */
export function getFormDataFromSession(session: SessionContextType): any {
    return session.getJsonFromSession(PARAMETER_FORMDATA);
}

/**
 * Restores form data from session and cleans up the restore flag
 * @param formInput The form input object to update
 * @param formDataFromSession The form data from session
 * @param session The session context (optional)
 * @returns The updated form input object
 */
export function restoreFormDataFromSession(formInput: any, formDataFromSession: any, session?: SessionContextType): any {
    if (formDataFromSession) {
        formInput.sessionFormData = formDataFromSession;
    }

    // If session is provided, also restore product form data
    if (session) {
        if (formInput.donationProductParameters) {
            const currentProductData = {
                productGreeting: formDataFromSession.productGreeting,
                productQuantity: formDataFromSession.productQuantity,
                productFirstname: formDataFromSession.productFirstname,
                productSurname: formDataFromSession.productSurname
            };
            session.addJsonToSession(SESSION_PARAM_PRODUCT_FORM_DATA, currentProductData);
        }
    }
    return formInput;
}
